/******************************************************************************************
 *	Numbers Only Directive
 *******************************************************************************************
 *
 * Only allows positive whole numbers to be entered into target input.
 * You can specify max and min values via max-num and min-num attributes on the element.
 *
 */

(function() {
  

  angular.module('rcDirectives.numbersOnly', []).directive('numbersOnly', function(_) {
    return {
      restrict: 'A',
      require: 'ngModel',
      scope: {
        minNum: '@',
        maxNum: '@'
      },
      link: function(scope, element, attrs, ctrl) {
        function inputValue(val) {
          if (val) {
            // Disallow non-digit entries
            var digits = _.replace(val, /[^0-9]/g, '');

            if (digits !== val) {
              ctrl.$setViewValue(digits);
              ctrl.$render();
            }

            // Validate input against max & min, if provided
            var maxIsValid = true,
              minIsValid = true;

            if (attrs.maxNum && !isNaN(attrs.maxNum)) {
              if (parseInt(digits) > parseInt(attrs.maxNum, 10)) {
                maxIsValid = false;
              }
              ctrl.$setValidity('max', maxIsValid);
            }
            if (attrs.minNum && !isNaN(attrs.minNum)) {
              if (parseInt(digits) < parseInt(attrs.minNum, 10)) {
                minIsValid = false;
              }
              ctrl.$setValidity('min', minIsValid);
            }

            return maxIsValid & minIsValid ? parseInt(digits, 10) : undefined;
          }
          return undefined;
        }
        ctrl.$parsers.push(inputValue);
      }
    };
  });
})();
